/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Content({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Picture/Upload/ImagePreview/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let imageCaptureQuestionAnswerPreviewValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'answer.preview',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<img
  data-testid="Content.Image"
  data-view-path={viewPath}
 alt={""}
 src={imageCaptureQuestionAnswerPreviewValueData}
 className={`views-block ${styles.Image}`}
/>
</div>
{children}
</React.Fragment>)
}